export default "__VITE_ASSET__DHDMNsZ3__"